import { render, staticRenderFns } from "./JwJiaocaiKucunList.vue?vue&type=template&id=44bf6981"
import script from "./JwJiaocaiKucunList.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiKucunList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports